import { call, isNativeHost } from "@/bridge/bridge";
import { showToast, type ToastKind } from "@/components/ui/Toast";

export function notify(kind: ToastKind, message: string): void {
  if (isNativeHost()) {
    void call("ui.toast", { kind, message }).catch(() => {
      // An older shell without ui.toast simply stays quiet; the screen it was
      // called from has already handled the failure itself.
    });
    return;
  }
  showToast({ kind, message });
}
